export default __webpack_public_path__ + "78a98529046e7180a7a5187b7c9fc2f2.svg";